import { render } from "./ServiceEdit.vue?vue&type=template&id=28b4d2a8&scoped=true"
import script from "./ServiceEdit.vue?vue&type=script&lang=js"
export * from "./ServiceEdit.vue?vue&type=script&lang=js"

import "./ServiceEdit.vue?vue&type=style&index=0&id=28b4d2a8&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b4d2a8"]])

export default __exports__